var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuideIconShortcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 33,
    viewBox: "0 0 18 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40886 10.7452L8.48569 9.86825L3.91204 9.79272V7.58364C3.91204 7.58364 3.75624 7.16406 2.40101 7.16406C1.04577 7.16406 0.618926 8.46056 0.618926 8.46056L0.463128 17.6808C0.463128 17.6808 1.08419 19.8521 3.21628 19.3948L2.28576 30.7884L0.271047 31.3989L0 32.9996H10.8931L12.1715 28.4262L14.9247 27.7402L15.7378 25.2626L13.4905 25.8332C13.4905 25.8332 12.1779 20.4794 11.7852 20.0032C11.3925 19.527 7.6384 18.7067 7.6384 18.7067L8.04391 14.2822L8.41313 10.7431L8.40886 10.7452ZM6.47098 21.5283L9.68726 21.8325L11.7809 26.0997L9.99886 26.557L10.9315 22.6801L10.2336 21.3836L8.17836 29.3388L4.14681 30.2535L6.47312 21.5283H6.47098Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1819 0.266602L9.32031 2.0582L15.2513 3.69666L16.1819 0.266602Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0462 0.304195L17.2477 0L11.5301 20.8447L10.4844 20.5384L16.0462 0.304195Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52665 8.85763C7.83148 8.85763 8.88924 7.81787 8.88924 6.53526C8.88924 5.25265 7.83148 4.21289 6.52665 4.21289C5.22183 4.21289 4.16406 5.25265 4.16406 6.53526C4.16406 7.81787 5.22183 8.85763 6.52665 8.85763Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7459 11.5085L7.28776 13.7763C6.94202 13.8728 6.58347 13.2246 6.48529 12.8868L6.39992 12.5952C6.30175 12.2554 6.50236 11.8987 6.84811 11.8022L13.302 9.98543C13.6478 9.88893 14.0106 10.0861 14.1088 10.426L14.1941 10.7176C14.2923 11.0575 14.0917 11.4141 13.7459 11.5106V11.5085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideIconShortcut);
export default __webpack_public_path__ + "static/media/GuideIconShortcut.295401c3b4d0a0c3eb6832155059473c.svg";
export { ForwardRef as ReactComponent };